import { FormState } from "src/interfaces/profile-setup.interface";
import { create, StateCreator } from "zustand";
import { persist } from "zustand/middleware";
import { getBuyerCommissionFee, likeProduct } from "../services/product.service";
import { getChangeableTitles } from "../services/getAttributes.service";

type Option = any;

interface State {
  user: {
    full_name: string;
  };
  selectedCountryId: number | null;
  setSelectedCountryId: (id: number) => void;
  selectedStateId: number | null;
  setSelectedStateId: (id: number) => void;
  buyerProtectionFee: number;
  fetchBuyerProtectionFee: () => void;
  likeProduct: (productId: number) => void;
  searchOptions: Option[];
  setSearchOptions: (options: Option[]) => void;
  changeableTitles: Record<string, string>;
  fetchChangeableTitles: () => void;
}

const createStore: StateCreator<State> = (set, get) => ({
  user: {
    full_name: "Template",
  },
  selectedCountryId: null,
  setSelectedCountryId: (id: number) => set({ selectedCountryId: id }),
  selectedStateId: null,
  setSelectedStateId: (id: number) => set({ selectedStateId: id }),
  buyerProtectionFee: 0,
  fetchBuyerProtectionFee: async () => {
    const currentFee = get().buyerProtectionFee;
    if (currentFee !== 0) return;

    try {
      const fee = await getBuyerCommissionFee();
      set({ buyerProtectionFee: fee });
    } catch (error) {
      console.error("Failed to fetch buyer protection fee:", error);
    }
  },
  likeProduct: async (productId: number) => {
    try {
      await likeProduct(productId);
      // Optionally update the state to reflect the like status
    } catch (error) {
      console.error("Failed to like product:", error);
    }
  },
  searchOptions: [],
  setSearchOptions: (options: Option[]) => set({ searchOptions: options }),
  changeableTitles: {},
  // fetchChangeableTitles: async () => {
  //   try {
  //     const response = await getChangeableTitles();
  //     set({ changeableTitles: response });
  //   } catch (error) {
  //     console.error("Failed to fetch changeable titles:", error);
  //   }
  // },
  fetchChangeableTitles: async () => {
    if (Object.keys(get().changeableTitles).length > 0) return;

    try {
      const response = await getChangeableTitles();
      set({ changeableTitles: response });
    } catch (error) {
      console.error("Failed to fetch changeable titles:", error);
    }
  },
});

export const useMultiStepFormStore = create<FormState>((set) => ({
  formData: {
    mobile_no: "",
  },
  setFormData: (data) =>
    set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () =>
    set({
      formData: {
        mobile_no: "",
      },
    }),
}));

const customStorage = {
  getItem: (name: string) => {
    const item = localStorage.getItem(name);
    return item ? JSON.parse(item) : null; // Ensure the value is parsed
  },
  setItem: (name: string, value: any) => {
    localStorage.setItem(name, JSON.stringify(value)); // Ensure the value is stringified
  },
  removeItem: (name: string) => {
    localStorage.removeItem(name);
  },
};

// let useStore: any;

// export const useStore = create(
//   persist<State>((set) => createStore(set), {
//     name: "user-store",
//     storage: customStorage, // Use the custom storage
//   }),
// );

export const useStore =
  typeof window !== "undefined"
    ? create(
      persist<State>(createStore, {
        name: "user-store",
        storage: customStorage,
      }),
    )
    : create(createStore);
